<a
  nz-popconfirm
  [nzPopconfirmTitle]="popupTitle"
  [nzPopconfirmPlacement]="popupPlacement"
  (nzOnConfirm)="download()"
  nzOkText="Tải về"
  nzCancelText="Hủy"
  [nzCondition]="condition"
  [nzIcon]="iconTpl"

>
  <ng-content></ng-content>
  <ng-template #iconTpl>
    <span nz-icon nzType="exclamation-circle" style="color: yellow;" nzTheme="outline"></span>
  </ng-template>
</a>
